import {Component, inject, OnInit, signal, WritableSignal} from '@angular/core';
import {forkJoin} from 'rxjs';
import {CompanyService} from '@services/company.service';
import {ICompanyDetailsSimplified} from '@models/company.interface';
import {ITransmitItem} from '@models/workspace.interface';

interface PortalEntry {
  company: ICompanyDetailsSimplified;
  items: ITransmitItem[];
}

@Component({
  selector: 'app-expert-portal',
  templateUrl: './expert-portal.html',
})
export class ExpertPortal implements OnInit {
  private readonly companyService = inject(CompanyService);

  loading = signal(true);
  entries: WritableSignal<PortalEntry[]> = signal([]);
  expandedClient = signal<string | null>(null);
  activeTab = signal<'documents' | 'messages' | 'required'>('documents');

  ngOnInit(): void {
    this.companyService.getCompanies().subscribe({
      next: (companies) => {
        if (!companies.length) {
          this.entries.set([]);
          this.loading.set(false);
          return;
        }
        forkJoin(companies.map((company) => this.companyService.getTransmitItems(company.siret))).subscribe({
          next: (results) => {
            this.entries.set(companies.map((company, index) => ({company, items: results[index] || []})));
            this.loading.set(false);
          },
          error: () => {
            this.entries.set(companies.map((company) => ({company, items: []})));
            this.loading.set(false);
          },
        });
      },
      error: () => {
        this.entries.set([]);
        this.loading.set(false);
      },
    });
  }

  totalItems(): number {
    return this.entries().reduce((sum, entry) => sum + entry.items.length, 0);
  }

  pendingCount(): number {
    return this.entries().filter((entry) => entry.items.length > 0).length;
  }

  toggleClient(siret: string): void {
    this.expandedClient.update((current) => current === siret ? null : siret);
    this.activeTab.set('documents');
  }
}
